module.exports = __webpack_public_path__ + "img/9788937450501.359e024c.jpg";